import { $, _ } from "../../../helpers/dom-selectors.js";
import App from "./init/app.js";
(async function () {
    const overlays = $(document, '.overlay');
    overlays.forEach(overlay => overlay.classList.remove('no-display'));
    const app = App({
        settingsBtn: _('settingsBtn'),
        settingsOverlay: _('settingsOverlay'),
        header: _('header'),
        logo: _('logo')
    });
    app.resize();
    window.addEventListener('app-event', (e) => {
        app.executeEvent(e.detail.action);
    });
    window.addEventListener('app-event-with-data', (e) => {
        app.executeEventWithData(e.detail);
    });
    window.addEventListener('resize', app.resize);
    document.documentElement.addEventListener('touchstart', function (e) { }); //hover behaviour on touch devices
})();
